import { makeAutoObservable } from 'mobx';

import type { MissionItem, PlanFile, GeoFence, RallyPoints } from '../types/Plan';

export type PlannerMode = 'Mission' | 'GeoFence' | 'Rally Point';
export type MissionTool = 'File' | 'Takeoff' | 'Waypoint' | 'Pattern' | 'Return' | 'None';

class MissionPlannerStore {
  mode: PlannerMode = 'Mission';

  missionItems: MissionItem[] = [];

  geoFence: GeoFence | null = null;

  rallyPoints: RallyPoints | null = null;

  selectedIndex: number | null = null;
  activeTool: MissionTool = 'None';

  constructor() {
    makeAutoObservable(this);
  }

  setMode(mode: PlannerMode) {
    this.mode = mode;
  }

  setActiveTool(tool: MissionTool) {
    this.activeTool = tool;
  }

  addMissionItem(item: MissionItem, index?: number) {
    if (index !== undefined) {
      this.missionItems.splice(index, 0, item);
    } else {
      this.missionItems.push(item);
    }
  }

  updateMissionItem(index: number, updates: Partial<MissionItem>) {
    if (this.missionItems[index]) {
      Object.assign(this.missionItems[index], updates);
    }
  }

  removeMissionItem(index: number) {
    if (this.missionItems[index]) {
      this.missionItems.splice(index, 1);
      if (this.selectedIndex !== null && this.selectedIndex >= this.missionItems.length) {
        this.selectedIndex = this.missionItems.length > 0 ? this.missionItems.length - 1 : null;
      }
    }
  }

  selectItem(index: number | null) {
    this.selectedIndex = index;
  }

  clearAll() {
    this.missionItems = [];
    this.geoFence = null;
    this.rallyPoints = null;
    this.selectedIndex = null;
  }

  loadPlan(plan: PlanFile) {
    this.missionItems = plan.mission.items;
    this.geoFence = plan.geoFence ?? null;
    this.rallyPoints = plan.rallyPoints ?? null;
  }

  exportPlan(): PlanFile {
    return {
      fileType: 'Plan',
      groundStation: 'SiFly',
      version: 1,
      mission: {
        version: 1,
        firmwareType: 0,
        vehicleType: 0,
        cruiseSpeed: 0,
        hoverSpeed: 0,
        globalPlanAltitudeMode: 0,
        plannedHomePosition: [0, 0, 0],
        items: this.missionItems
      },
      geoFence: this.geoFence ?? undefined,
      rallyPoints: this.rallyPoints ?? undefined
    };
  }
}

export const missionPlannerStore = new MissionPlannerStore();
export default MissionPlannerStore;
